import { render } from "./MenuLanguageItem.vue?vue&type=template&id=51bba7f1&scoped=true"
import script from "./MenuLanguageItem.vue?vue&type=script&lang=js"
export * from "./MenuLanguageItem.vue?vue&type=script&lang=js"

import "./MenuLanguageItem.vue?vue&type=style&index=0&id=51bba7f1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bba7f1"]])

export default __exports__